// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__IU2HgK6DxqkU-"};